import * as angular from "angular";

export function initConfig(app: angular.IModule) {
    /* @ngInject */
    app.config(function ($httpProvider: angular.IHttpProvider) {
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.interceptors.push((ORIGIN: string) => {
            return {
                "request": function (config) {
                    const changeUrl = config.url.search('/v2/launch-darkly') === -1;
                    if (/^\//.test(config.url) && changeUrl) {
                        config.url = `${ORIGIN}${config.url}`;
                    }
                    return config;
                }
            };
        });
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/app.config.ts